import { installDateRangeValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installCallbackValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installIsSameOrAfterValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installLtValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installTimeValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installGtValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installIsAfterValidator } from '@fifa-bsm/bo-frontend-shared/validators';
import { installBooleanValidator } from '@fifa-bsm/bo-frontend-shared/validators';

export { validateDateRange } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateWithCallback } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateIsAfter } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateIsSameOrAfter } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateLt } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateTime } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateGt } from '@fifa-bsm/bo-frontend-shared/validators';
export { validateBoolean } from '@fifa-bsm/bo-frontend-shared/validators';

export const installAllValidators = () => {
    installDateRangeValidator();
    installCallbackValidator();
    installIsAfterValidator();
    installIsSameOrAfterValidator();
    installLtValidator();
    installGtValidator();
    installTimeValidator();
    installBooleanValidator();
};
